<template>
  <div style="width: 100%;overflow: hidden;">
    <headerTop />
    <el-form ref="form" :model="form" label-width="100px">
      <el-row style="width: 1440px;margin: 0 auto;">
        <el-col :span="24">
          <el-row>
        <el-col :span="12">
          <el-form-item label="收货人">
            <el-input :disabled="true" style="width: 370px" type="text" placeholder="请输入内容"
              v-model="defaultAddress.realName">
              <el-button slot="append" icon="el-icon-search" @click="switchAddress"></el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="电话">
            <el-input :disabled="true" style="width: 370px" type="text" placeholder="请输入内容"
              v-model="defaultAddress.phone">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="项目名称" prop="projectName" :rules="{
            required: true,
            message: '项目名称不能为空',
            trigger: 'blur',
          }">
            <el-input style="width: 370px" type="text" :disabled="true" v-model="form.projectName">
              <el-button slot="append" icon="el-icon-search" @click="checkName(form.projectName)"></el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="地址">
            <el-input :disabled="true" style="width: 370px" type="text" placeholder="请输入内容"
              v-model="defaultAddress.province + defaultAddress.city + defaultAddress.district + defaultAddress.detail">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="需求日期" :rules="{ required: true, message: '需求日期不能为空', trigger: 'blur'}">
            <el-date-picker v-model="form.demandDate" :picker-options="pickerOptions" type="date" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd" placeholder="请选择日期" style="width: 370px">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="备注">
            <el-input style="width: 370px" type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" placeholder="请输入内容"
              v-model="form.remark">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-form-item style="margin: 0px -90px;">
          <el-col :span="1.5">
            <el-button type="primary" @click="addList()" size="small">增加</el-button></el-col>
          <el-col :span="1.5">
            <el-button type="danger" @click="delData()" size="small">删除</el-button></el-col>
          <el-col :span="1.5">
            <el-button type="warning" @click="dowExcel()" size="small">下载模版</el-button></el-col>
          <el-col :span="5">
            <el-upload action="#" :auto-upload="false" :file-list="[]" :on-change="handleChange1" :data="{ type: 1 }"
              multiple>
              <el-button type="success" size="small">Excel清单上传</el-button>
            </el-upload></el-col>
        </el-form-item>
      </el-row>
      <el-table :data="detailList" style="width: 100%" :row-class-name="tableRowClassName" stripe border
        @selection-change="handleSelectionChange" :header-cell-style="{
          background: '#EEEEEE',
          height: '50px',
          color: 'black',
          border: '1px solid #d3d3d3'
        }">
        <el-table-column type="selection" width="55" :selectable="canBeSelect"> </el-table-column>
        <el-table-column label="序号" type="index" width="50">
        </el-table-column>
        <el-table-column prop="unique" label="商品编码" align="center" header-align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.unique" type="text" @change="handlerChange(scope)" />
          </template>
        </el-table-column>
        <el-table-column prop="cartNum" label="需求数量" align="center" width="80" header-align="center">
          <template slot-scope="scope">
            <!-- <el-input v-model="scope.row.cartNum" type="text" @change="cartNumChange(scope)" /> -->
            <el-input-number v-model="scope.row.cartNum" @change="cartNumChange(scope)" @blur="inputNumBlur(scope.row,'cartNum')" :min="0" :step="1" :step-strictly="true" :controls="false" :disabled="disabled"/>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="storeName" label="商品名称" header-align="center" width="160"
          :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column align="center" prop="image" label="图片" header-align="center" width="160">
          <template slot-scope="scope">
            <el-image style="width: 50px; height: 50px; margin-bottom:-4px"
              :src="scope.row.image ? scope.row.image : '../../../static/images/mr@2x.png'">
            </el-image>
          </template></el-table-column>
        <el-table-column prop="sku" label="规格" header-align="center" align="center" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="stock" label="库存">
        <template slot-scope="scope">
          <span>{{ scope.row.stock===0?'已下架': scope.row.stock}}</span>
        </template>
      </el-table-column>
        <el-table-column prop="unitName" align="center" label="单位名称" width="150" header-align="center"
          :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="price" label="单价" header-align="center" width="150" align="center">
        </el-table-column>
        <el-table-column fixed="right" align="center" header-align="center" label="操作" width="180">
          <template slot-scope="scope">
            <el-button type="danger" size="small" @click="delList(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-form-item style="margin: 10px -100px">
        <el-upload class="upload-demo" :action="action" :headers="headers" :on-preview="handlePreview"
          :on-success="AttachOnSuccess" multiple :limit="8" :show-file-list="showlist">
          <el-button size="small" type="primary">上传附件</el-button>
        </el-upload>
        <el-table :data="newList" border stripe :show-header="false" style="width: 550px" v-if="newList.length > 0">
          <el-table-column prop="FileName" label="文件名称">
            <template slot-scope="scope">
              <el-button size="small" type="text">
                <a @click="linkDownload(scope.row.fileUrl)">{{
                  scope.row.fileName
                }}</a>
              </el-button>
            </template>
          </el-table-column>
          <el-table-column width="80px">
            <template slot-scope="scope">
              <el-button size="small" type="text">
                <a target="_blank" :href="scope.row.fileUrl">下载</a>
              </el-button>
            </template>
          </el-table-column>
          <el-table-column width="80px">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="deleteButton(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item style="margin-left: 30%;margin-top:20px">
        <el-button type="primary" @click="onSubmit">提交</el-button>
      </el-form-item>
    </el-form>

    <!-- 添加/编辑收货地址 -->
    <AddAddress :addVisible="addVisible" :options="options" :newAddress="newAddress" :value="value"
      @addClose="addClose" />
    <!-- 更换收货地址 -->
    <el-dialog title="请选择您的收货地址" :visible.sync="switchVisible" width="45%" center :before-close="switchClose">
      <div class="addressList2">
        <div class="addressBox2 flex" :class="addressIndex === index ? 'active2' : ''" v-for="(item, index) in addressList"
          :key="item.id" @click="selectAddress(index)">
          <div class="flex3 col-333">
            <p><span class="col-999" style="width:70px;display: inline-block;">收货人:</span>{{ item.realName }} {{ item.phone }}
            </p>
            <p><span class="col-999" style="width:70px;display: inline-block;">地址:</span>{{ item.province + item.city +
              item.district + item.detail }}</p>
          </div>
          <div class="flex1 tar col-999">
            <span class="edit cur-poi" @click="edit(item)">编辑</span>
            <br>

          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="close" plain @click="switchClose">取消</el-button>
        <el-button class="submit" plain @click="switchSave">保存</el-button>
      </span>
    </el-dialog>
    <el-dialog title="商品列表" :visible.sync="dialogTableVisible">
      <bpm :uItem="uItem" :dialogTableVisible="dialogTableVisible" @dialogRes="dialogRes" @beforeInit="beforeInit">
      </bpm>
    </el-dialog>
    <el-dialog title="项目列表" :visible.sync="dialogName">
      <names :nItem="nItem" :dialogName="dialogName" @namesRes="namesRes">
      </names>
    </el-dialog>
    <el-dialog title="合同条款及规则" :close-on-press-escape="false" :close-on-click-modal="false"
      style="width: 145%; left: -300px; top:-80px" center :visible.sync="centerDialogVisible">
      <el-scrollbar style="height:500px">

        第一条 定义</br>
        1.1一般货物：由乙方根据技术协议确定的技术标准生产并根据本合同销售给甲方的货物。</br>
        1.2技术协议：指由甲方和乙方签署的确定对其适用的技术标准的协议，本合同的全部技术标准应在技术协议中约定。</br>
        1.3技术资料：与一般货物设计、生产、制造、验收、检验、安装、运行等有关的一切设计图纸、生产图纸、工艺文件、流程图、说明书、零件图册、操作手册（规范）等文件。双方应在技术协议中对技术资料的具体范围进行详细规定。</br>
        第二条 包装</br>
        2.1
        货物由乙方合理包装并符合技术附件的要求（如有），适合水运或长途内陆运输，具有防潮，防湿，防震，防锈功能，符合甲方使用要求。危险品包装需符合国家和地方安全环保规定。如因包装不当给甲方或其他第三方造成的损失和责任均由乙方承担。</br>
        2.2 乙方应根据货物运输要求，于每件包装上印刷包装编号、尺码、毛重、净重、提吊位置及“此端向上”、“小心轻放”，“切勿受潮”等注意事项，由于包装不当而造成的损失均由乙方承担。</br>
        2.3 包装物由乙方提供，#{条款.14.业务条款内容}，其他包装物约定：#{条款.15.业务条款内容}。</br>
        第三条 合理耗损</br>
        以双方共同确定的计量方式为准，合理损耗为（#{条款.16.业务条款内容}）%，实际交付的货物数量在本合同约定的损耗范围内（含），乙方不承担违约责任。</br>
        第四条 溢、短装</br>
        合同溢、短装为合同数量的±#{条款.17.业务条款内容}%。实际数量在溢短装范围内的，按实际交付数量结算；溢装超出范围的，甲方不另付款，短装超出范围的，乙方应补足并承担违约责任。</br>
        第五条 标的物的风险及所有权的转移</br>
        5.1 标的物的风险自甲方验收合格后转移至甲方。标的物在未经甲方验收合格前的毁损、灭失等其他一切风险由乙方负责。</br>
        5.2 标的物的所有权自交付时起转移至甲方。</br>
        5.3 乙方迟延交付的，承担迟延期间标的物的风险责任。货物经甲方同意分批发运的，每批货物的风险及所有权按照5.1、5.2款规定转移。</br>
        第六条 验收</br>
        6.1 验收标准：按本合同约定的质量标准进行检验。</br>
        6.2 若乙方知道或者应当知道所卖出货物存在质量缺陷，所承担的质量保证期不受前款约定质保期的约束，甲方有权无条件退换货，直到达到合同要求；若更换后仍不能达到甲方要求，甲方有权另行采购，所产生的的费用由乙方承担。</br>
        6.3 验收地点：在甲方指定的地点对货物进行验收。</br>
        6.4 货物验收不合格的，甲方有权拒收货物，由此产生的损失及违约责任，由乙方承担。</br>
        6.5
        如双方对货物是否存在质量问题有争议，应由共同确认的检验机构对封存的样品进行检验，并以该检验机构的检验结果作为确认货物质量的依据。如检验结果证明货物不符合合同约定的质量标准，检验费由乙方承担；符合质量标准的，检验费由甲方承担。</br>
        第七条 知识产权和保密</br>
        7.1
        乙方保证提供给甲方的货物、服务和技术附件等文件，不侵犯任何第三方关于专利、商标、版权或工业设计权利等知识产权。如因购买、使用乙方提供的上述服务或使用乙方提供的上述物品而受到第三方对于甲方侵犯其知识产权诉讼和索赔，将由乙方承担由此引发的一切责任和后果。</br>
        7.2 如发生本条第7.1款约定的任何侵犯第三方知识产权侵权，甲方应通知乙方，乙方应立即负责与第三方交涉处理此事，并承担一切由此引起的法律和经济责任，使甲方免受因第三方索赔而承担法律及经济责任所造成的损失。</br>
        7.3 如发生侵权事件或存在侵权可能性，乙方应在知晓该时间之日起48小时内书面通知甲方，并采取合理措施消除影响。</br>
        7.4
        任何一方为履行本协议项下或与本协议相关义务，而向另一方提供的包括但不限于专有技术、技术文件、设计图纸、商业资料等文件资料，接受方应承担保密义务，除为履行本协议或与本协议相关义务目的除外，未经提供方书面同意，均不得提供给任何其他第三方。</br>
        7.5 任何一方均不得将本合同的存在及内容作为商业宣传资料，乙方不得通过甲方提供的信息、渠道等，与上下游公司等关联方洽谈业务，进行商业合作。</br>
        第八条 违约责任</br>
        8.1 如乙方未按期交货 (不可抗力除外)，应承担以下迟交货违约责任:</br>
        （1）每迟交1日历日应支付迟交部分货值千分之五 的违约金，乙方支付违约金并不解除其交货义务，交货时间由双方另行商定。</br>
        （2）逾期交货超过（ 30 ）个日历日，甲方有权按本合同约定解除本合同或采购订单。乙方除支付迟交货违约金外还应赔偿因此给需方造成的损失。</br>
        （3）分期交货情况下，如乙方部分交货延迟导致合同被单方解除，甲方有权就已接收部分货物向乙方要求退货，乙方应退还该部分货款、承担退货费用并赔偿因此给甲方造成的损失。</br>
        8.2 如乙方交付的货物不符合约定的数量，乙方应当承担合同总金额20%的违约金并在甲方要求的期限内补足。</br>
        8.3
        如乙方交付的货物不符合本协议的质量要求和规定指标，甲方有权拒收货物并要求乙方更换，乙方应在甲方要求的期限内提供合格货物，并承担迟延交货的违约责任。如乙方未在该期限内提供合格货物的，甲方有权解除合同并由乙方承担因此给甲方造成的损失。</br>
        8.4 如乙方发生本条所述违约行为未向甲方支付合同金额的百分之二十的违约金，甲方有权从应付货款中直接扣除，但应当书面通知乙方。</br>
        8.5如果合同一方未能履行其在本合同项下的合规义务，守约方可书面通知违约方并要求违约方在收到该通知之日起三十（30）日内对该违约予以补救。如果该违约无法补救，或未能在规定时间内予以补救，守约方有权解除合同。因违约方的违约行为导致守约方承担责任或遭受损失，守约方有权要求违约方给予经济赔偿。</br>
        8.6如发生本条或本协议其他条款未尽的其它违约情形，违约方应赔偿由此给守约方造成的损失。如违约系双方过错造成，应按各自责任比例承担违约责任。</br>
        第九条 不可抗力</br>
        由于不可抗力导致合同一方或双方不能部分或者全部履行本合同义务，受不可抗力影响的合同方将得以免除部分或全部不能履行合同义务的责任，但应在不可抗力发生后24小时内通知对方，并在通知后14个工作日内向对方提供有效证明文件。受不可抗力影响的合同方有义务采取措施将不可抗力造成的损失降到最低。如不可抗力时间持续超过60个日历日，则甲方有权选择终止本合同。此种情况下，双方应妥善协商及处理各项合同事宜。</br>
        第十条 争议解决</br>
        凡与本合同有关或因本合同引起的任何争议，包括但不限于合同的违反、解除、终止和效力应由双方友好协商解决，经双方协商未达成一致的，按（ 2 ）执行：</br>
        （1）任何一方可将该争议向甲方所在地法院提起诉讼；</br>
        （2）任何一方可将该争议向（德州）仲裁委员会提起仲裁；</br>
        （3）甲乙双方均为格瑞德内部单位的，应将任何争议提交格瑞德内部法律纠纷调解小组调处。</br>
        第十一条 变更和解除</br>
        11.1 本合同的变更需经双方协商一致，变更合同自双方签字盖章后生效。在变更合同签署生效前，任何一方应保证本合同正常执行。</br>
        11.2
        甲方有权部分或全部解除采购合同并就解除部分中乙方不能自行处理或没有其他用途的部分向乙方提供合理补偿。补偿范围仅限于由该解除使乙方实际产生的直接合理的费用，包括已购原材料，生产成本及合理的管理费用。乙方应提供已投入生产的成本证据。甲方支付补偿后，取得被解除采购合同下原材料的所有权，乙方应根据甲方要求在合理期限内免费为甲方储存和保管。</br>
        11.3 有下列情形之一者，甲方有权立即单方解除本合同，乙方应赔偿因解除给甲方造成的损失：</br>
        （1）未经甲方书面同意，将部分或全部权利义务转让给第三方。</br>
        （2）在合同有效期内，货物出现重大质量问题。</br>
        （3）乙方延迟交货超过（ 30 ）个日历日。</br>
        （4）乙方发生破产、清算等情况，丧失履约能力。</br>
        （5）乙方有其他严重违约行为，导致本合同目的无法实现。</br>
        （6）被格瑞德集团暂停交易资格或从供应商网络中除名的。</br>
        第十二条 商业道德</br>
        甲乙签署的有关廉洁从业的文件作为本合同的组成部分，与本合同具有同等法律效力。双方违反该合同之行为，应被视为违反本合同的违约行为，应向未违约方承担相应的违约责任。</br>
        第十三条 健康、安全和环境保护</br>
        乙方应在设备生产、存储、运输、交付、安装调试、验收等过程中，遵守中华人民共和国质量、安全、环境与健康等法律法规的有关要求，并承担质量、安全、环境与健康责任。乙方还应遵守甲方的HSSE要求。</br>
        第十四条 通知</br>
        本合同要求的或允许的任何通知、要求或其他书面文件应当由发出该通知的一方书面签署，并以专人送递或邮寄的方式送至对方联系人地址，合同中约定的双方地址即为默认送达地址，如发生变更，应及时通知合同相对方，在取得对方接收确认或到达指定电子通讯设施后，即被认为已送达。</br>
        第十五条 生效及其他</br>
        15.1合同各方保证其根据其成立地的法律依法定程序设立，有效存在且相关手续完备，已取得开展合同项下业务所需的所有政府审批、许可或资质；合同各方知晓并将严格遵守与执行本合同相关的法律法规、监管规则、标准规范，依法依规行使合同权利，履行合同义务，不得从事任何可能导致合同方承担任何行政、刑事责任或处罚的行为。</br>
        </span>

      </el-scrollbar>
      <el-checkbox v-model="checked" style="margin:20px 50px" @change="offCheck">同意此协议</el-checkbox>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="agree()">同意</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getToken } from "@/axios/cookies.js";
import { uploads } from "@/api/user.js";
import { getUserInfo } from "@/api/login.js";
import {
  fastCreateOrder,
  clearAllCache,
  getInventoryDetail,
  clearCacheBySkuCode,
  getGoodsByCode,
  getFastCreateOrderCache,
  saveOrUpdateCache,
} from "@/api/noticedetail.js";
import headerTop from "@/components/base/headerTop.vue";
import { selectAgreementByUid, AddUserAgreement } from "@/api/cart.js";
import bpm from "../addInventory/bpm.vue";
import names from "../addInventory/names.vue";
import { mapGetters } from "vuex";
import TencentMap from "@/components/common/TencentMap";
import AddAddress from "@/components/common/addAddress";

import { getCityData, getAddressData } from "@/api/user.js";

export default {
  name: "notice",
  components: { bpm, names, TencentMap, AddAddress, headerTop },
  data() {
    return {
      showlist: false,
      headers: {
        Authorization: getToken(),
        tenantId: "0000",
      },
      fileList: [],
      newList: [],
      action: uploads,
      checkRow: [],
      goodsList: [],
      checked: false,
      fileTemp: null,
      centerDialogVisible: false,
      file: "",

      list: [],
      tableData1: null,
      accountList: null,
      disabled: false,
      lineCode: 2,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      options: [],
      value: {
        label: [],
      },
      uItem: null,
      defaultAddress: { realName: "" },
      form: {
        projectId: null,
        projectName: "",
        projectCode: "",
        address: {
          city: null,
          cityId: null,
          province: null,
          district: null,
        },
        status: null,
        detail: null,
        expectDate: "",
        demandDate: "",
        remark: "",
        createUserType: "",
      },
      detailList: [],
      lists: [],
      userName: "",
      phone: "",
      check: false,
      userId: null,
      upList: [],
      uid: null,
      rowData: {},
      dialogTableVisible: false,
      dialogName: false,
      nItem: null,
      addVisible: false,
      switchVisible: false,
      addressList: [],
      addressIndex: null,
      newAddress: {
        real_name: null,
        phone: null,
        address: {
          city: null,
          cityId: null,
          provinceId: null,
          districtId: null,
          district: null,
          province: null,
        },
        id: null,
        detail: null,
        is_default: false,
      },
    };
  },
  computed: {
    ...mapGetters([
      "user", // 用户信息
      "uploadApi",
    ]),
  },
  watch: {
    options: {
      handler(nVal, oVal) {
        // console.log(nVal, oVal)
      },
      deep: true,
    },
  },
  async created() {
    this.getUserInfo();
    await this.getCityList();
    this.getAddressList();

    var id = this.$route.params.id;
    var type = this.$route.params.type;
    if (id && type === "see") {
      this.disabled = true;
      this.getDetail(this.$route.params.id);
    } else if (id && type === "edit") {
      this.getDetail(this.$route.params.id);
    }
  },

  methods: {
    AttachOnSuccess(response, file, fileList) {
      console.log(response);
      let fileArray = {
        fileName: response.link[0].fileName,
        fileUrl: response.link[0].fileUrl,
      };
      if (this.newList == null) {
        this.newList = new Array();
        this.newList.push(fileArray);
      } else {
        this.newList.push(fileArray);
      }
    },
    deleteButton(index) {
      this.newList.splice(index, 1);
    },
    handleRemove(file, fileList) {
      this.newList = file;
    },

    handlePreview(file) {
      console.log(file);
    },
    getCache() {
      getFastCreateOrderCache(this.userId).then((res) => {
        res.date.map((item) => {
          let obj = {
            id: item.id,
            image: item.image,
            cartNum: item.needNum,
            price: item.price,
            sku: item.sku,
            unique: item.skuCode,
            stock: item.stock,
            storeName: item.storeName,
            unitName: item.unitName,
            userId: item.userId,
          };
          this.detailList.push(obj);
        });
      });
    },
    tableRowClassName(row, index) {
      row.row.index = row.rowIndex;
    },
    handleSelectionChange(rows) {
      this.checkRow = rows;

      this.selectionItemIndexes = [];
      rows.forEach((item) => {
        this.selectionItemIndexes.push(item.index);
      });
    },
    // 编辑
    edit(item) {
      this.value.label = [];
      this.options.forEach((i) => {
        if (i.label === item.province) {
          this.newAddress.address.province = i.label;
          this.newAddress.address.provinceId = i.value;
          this.value.label.push(i.value);
          i.children.forEach((j) => {
            if (j.label === item.city) {
              this.newAddress.address.city = j.label;
              this.newAddress.address.cityId = j.value;
              this.value.label.push(j.value);
              j.children.forEach((k) => {
                if (k.label === item.district) {
                  this.newAddress.address.district = k.label;
                  this.newAddress.address.districtId = k.value;
                  this.value.label.push(k.value);
                }
              });
            }
          });
        }
      });
      this.newAddress.real_name = item.realName;
      this.newAddress.phone = item.phone;
      this.newAddress.detail = item.detail;
      this.newAddress.id = item.id;
      this.newAddress.is_default = !!item.isDefault;
      this.addVisible = true;
    },
    // 获取地址列表
    async getAddressList() {
      var res = await getAddressData();
      if (res.data.length === 0) {
        this.$message.warning("您当前没有任何地址，请添加一个地址！");
        this.$router.push({ path: "/address" });
        // this.addVisible = true
      }
      if (res.status === 200) {
        this.defaultAddress = res.data[0];
        this.addressList = res.data;

        this.addressList.forEach((i) => {
          this.$set(i, "selected", false);
        });
      } else {
        this.$message.warning(res.msg);
      }
    },
    // 重置数据
    reset() {
      this.newAddress = {
        real_name: null,
        phone: null,
        address: {
          city: null,
          cityId: null,
          provinceId: null,
          districtId: null,
          district: null,
          province: null,
        },
        detail: null,
        is_default: false,
      };
      this.value.label = [];
    },
    // 切换地址
    selectAddress(index) {
      this.addressIndex = index;
    },
    switchSave() {
      this.defaultAddress = this.addressList[this.addressIndex];
      // this.computedAmount()
      this.switchVisible = false;
      // location.reload()
    },

    // 打开添加收货地址弹窗
    addAddress() {
      this.addVisible = true;
    },

    // 打开更换收货地址弹窗
    switchAddress() {
      this.switchVisible = true;
    },

    // 关闭添加收货地址弹窗
    addClose(x) {
      if (x) {
        this.getAddressList();
      }
      this.addVisible = false;
      this.reset();
    },

    // 关闭更换收货地址弹窗
    switchClose() {
      this.switchVisible = false;
    },

    // 是否默认地址
    selectDefault() {
      this.newAddress.default = !this.newAddress.default;
    },

    offCheck() {
      this.check = !this.check;
    },
    async agree() {
      if (this.check) {
        let para = {
          userUid: this.userId,
          agreement: 1,
        };
        var res = await AddUserAgreement(para);
        if (res === true) {
          this.centerDialogVisible = false;
          this.$message({
            message: "同意协议成功",
            type: "success",
          });
        }
      } else {
        this.$message({
          message: "请勾选同意协议",
          type: "warning",
        });
      }
    },
    // 获取用户信息
    async getUserInfo() {
      var res = await getUserInfo();
      if (res.status === 200) {
        this.userId = res.data.uid;
        this.userName = res.data.username;
        this.phone = res.data.phone;
        this.getCache();
      } else {
        this.$message.warning(res.msg);
      }
    },
    checkUpList() {
      this.upList.forEach((item) => {
        getGoodsByCode(item.unique).then((res) => {
          if (res.success === true) {
            let a = res.date;
            a.cartNum = item.cartNum;
            this.detailList.unshift(a);
            this.detailList.forEach((item) => {
              let para = {};
              para["needNum"] = item.cartNum;
              para["skuCode"] = item.unique;
              para["userId"] = this.userId;
              var res = saveOrUpdateCache(para);
            });
          } else {
            this.$message({
              message: "上传的商品中部分不存在",
              type: "warning",
            });
          }
        });
      });
    },

    beforeInit() {
      this.url = "/system/user/getBpmUser";
      this.params = {
        page: this.page,
        size: this.size,
      };
      const query = this.query;
      const type = query.type;
      const value = query.value;
      if (type && value) {
        this.params[type] = value;
      }
      return true;
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    // 导入函数
    importfxx(obj) {
      let _this = this;
      // 通过DOM取文件数据
      this.file = obj;
      var rABS = false; // 是否将文件读取为二进制字符串
      var f = this.file;
      var reader = new FileReader();
      // if (!FileReader.prototype.readAsBinaryString) {
      FileReader.prototype.readAsBinaryString = function (f) {
        var binary = "";
        var rABS = false; // 是否将文件读取为二进制字符串
        var pt = this;
        var wb; // 读取完成的数据
        var outdata;
        var reader = new FileReader();
        reader.onload = function (e) {
          var bytes = new Uint8Array(reader.result);
          var length = bytes.byteLength;
          for (var i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          var XLSX = require("xlsx");
          if (rABS) {
            wb = XLSX.read(btoa(fixdata(binary)), {
              // 手动转化
              type: "base64",
              cellDates: true,
            });
          } else {
            wb = XLSX.read(binary, {
              type: "binary",
              cellDates: true,
            });
          }
          outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
          this.da = [...outdata];
          _this.lists = outdata;
          let lists = [];
          outdata.map((v) => {
            let obj = {};
            obj.unique = v["商品编码"];
            obj.cartNum = !isNaN(parseFloat(v["需求数量"])) && isFinite(v["需求数量"]) ? v["需求数量"]:1;
            // (obj.cartNum = v["需求数量"]), 
            lists.push(obj);
          });
          _this.upList = lists;
          _this.checkUpList();
        };
        reader.readAsArrayBuffer(f);
      };

      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
    },
    // 判断文件是否符合要求
    handleChange1(file, fileList) {
      this.fileTemp = file.raw;
      if (this.fileTemp) {
        // if((this.fileTemp.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') || (this.fileTemp.type == 'application/vnd.ms-excel')){
        if (
          this.fileTemp.name.indexOf("xls") != -1 ||
          this.fileTemp.name.indexOf("xlsx") != -1
        ) {
          this.importfxx(this.fileTemp);
        } else {
          this.$message({
            type: "warning",
            message: "附件格式错误，请删除后重新上传！",
            duration: 10000,
          });
        }
      } else {
        this.$message({
          type: "warning",
          message: "请上传附件！",
          duration: 10000,
        });
      }
    },
    dowExcel() {
      let a = document.createElement("a");
      a.href = "../../../static/test.xlsx";
      a.download = "快速下单模版.xlsx";
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      a.remove();
    },

    cartNumChange(e) {
      //数量变化暂存
      this.saveOrUpdateCache(e);
    },
    handlerChange(e) {
      // 不允许重复添加
      let arr = 0;
      for (let i = 0; i < this.detailList.length; i++) {
        if (this.detailList[i].unique === e.row.unique) {
          arr++;
          if (arr >= 2) {
            this.$message({
              message: "此商品已存在，请勿重新添加",
              type: "warning",
            });
            e.row.unique = "";
            return;
          }
        }
      }
      // 根据编码查询商品信息
      this.getGoods(e);
    },
    getGoods(e) {
      getGoodsByCode(e.row.unique).then((res) => {
        if (res.success === true) {
          //数据暂存
          this.saveOrUpdateCache(e);
          this.detailList.splice(e.$index, 1, res.date);
        } else {
          this.$message({
            message: "不存在此商品",
            type: "warning",
          });
        }
        this.canBeSelect(res.data)
      });
    },
    canBeSelect(row) {
    if ( row.stock===0) {
      return false;
    } else {
      return true;
    }
  },
    saveOrUpdateCache(e) {
      let para = {};
      para["needNum"] = e.row.cartNum;
      para["skuCode"] = e.row.unique;
      para["userId"] = this.userId;
      var res = saveOrUpdateCache(para);
    },

    getDetail(id) {
      getInventoryDetail(id)
        .then((res) => {
          this.form.status = res.status;
          this.form.demandDate = res.demandDate;
          this.form.expectDate = res.expectDate;
          this.form.address.city = res.city;
          this.form.address.cityId = res.cityId;
          this.form.address.cityId = res.provinceId;
          this.form.address.cityId = res.districtId;
          this.form.address.province = res.city;
          this.form.address.district = res.district;
          this.form.projectName = res.projectName;
          this.form.projectCode = res.projectCode;
          this.form.projectId = res.projectId;
          this.form.detail = res.detail;
          this.form.remark = res.remark;
          this.detailList = res.detailList;
          this.form.id = res.id;
        })
        .catch(() => { });
    },
    // 获取城市列表
    async getCityList() {
      var res = await getCityData();
      if (res.status === 200) {
        const json1 = JSON.parse(
          JSON.stringify(res.data).replace(/v/g, "value")
        );
        const json2 = JSON.parse(JSON.stringify(json1).replace(/n/g, "label"));
        const json3 = JSON.parse(
          JSON.stringify(json2).replace(/c/g, "children")
        );
        json3.forEach((i) => {
          i.children.forEach((j) => {
            j.children.forEach((k) => {
              delete k.children;
            });
          });
        });
        this.options = json3;
      } else {
        this.$message.warning(res.msg);
      }
    },

    dialogRes(a, data) {
      data.storeId = a.id;
      data.productName = a.productName;
      data.unique = a.unique;
      data.unitName = a.unitName;
      data.price = a.price;
      this.dialogTableVisible = false;
    },
    namesRes(a) {
      this.form.projectName = a.projectName;
      this.form.projectId = a.id;
      this.form.projectCode = a.projectCode;
      this.form.businessUserId = a.businessUserId;
      this.form.businessUserName = a.businessUserName;
      this.form.deptId = a.deptId;
      this.form.deptName = a.deptName;
      this.dialogName = false;
    },
    checkGoods(data) {
      this.dialogTableVisible = true;
      this.uItem = data;
    },
    checkName(data) {
      this.dialogName = true;
      this.nItem = data;
    },
    async seet() {
      let address = {};
      address.cityId = this.defaultAddress.id;
      address.city = this.defaultAddress.city;
      address.province = this.defaultAddress.province;
      address.district = this.defaultAddress.district;
      address.cityCode = this.defaultAddress.cityAreaCode;
      address.districtCode = this.defaultAddress.districtAreaCode;
      address.provinceCode = this.defaultAddress.provinceAreaCode;
      let listGoods = this.detailList.map((item) => ({
        uniqueId: item.unique,
        productId: item.id,
        new: 0,
        cartNum: item.cartNum,
      }));
      if (listGoods.length === 0) {
        this.$message({
          message: "请添加商品",
          type: "warning",
        });
      } else {
        let para = {};
        para["fileList"] = this.newList;
        para["address"] = address;
        para["cartParamQuickList"] = listGoods;
        para["detail"] = this.defaultAddress.detail;
        para["demandDate"] = this.form.demandDate;
        para["from"] = "pc";
        para["isChannel"] = "";
        para["payType"] = "remittance";
        para["projectCode"] = this.form.projectCode;
        para["projectName"] = this.form.projectName;
        para["projectId"] = this.form.projectId;
        para["remake"] = this.form.remark;
        para["username"] = this.defaultAddress.realName;
        para["phone"] = this.defaultAddress.phone;

        para["businessManId"] = this.userId;
        var res = await fastCreateOrder(para);
        if (res.status === 200) {
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          //清空所有缓存
          this.clearAllCache();
          // 链接到订单中的待发货
          this.$router.push("/myOrder");
        } else {
          this.$message({
            message: res.msg,
            type: "warning",
          });
        }
      }
    },
    clearAllCache() {
      let para = {};
      para["skuCodeList"] = [];
      para["userId"] = this.userId;
      var res = clearAllCache(para);
    },
    async onSubmit() {
      let paras = {
        uid: this.userId,
      };
      var res = await selectAgreementByUid(paras);
      if (res === true) {
        this.seet();
      } else {
        this.centerDialogVisible = true;
      }
    },
    addList() {
      var list = {
        lineCode: this.lineCode,
        materialCode: "",
        materialName: "",
        storeId: "",
        price: "",
        remark: "",
        cartNum: null,
        productName: "",
        unique: "",
        itemSpecs: "",
        unitCode: "",
        unitName: "",
      };
      this.detailList.push(list);
      this.lineCode += 1;
    },
    clearCache(skuCodeList) {
      let para = {};
      para["skuCodeList"] = skuCodeList;
      para["userId"] = this.userId;
      var res = clearCacheBySkuCode(para);
    },
    delData() {
      let list = [];
      this.checkRow.forEach((item) => {
        list.push(item.unique);
      });
      this.clearCache(list);
      this.detailList = this.detailList.filter((item, index) => {
        let arrlist = this.selectionItemIndexes;

        return !arrlist.includes(index);
      });
    },
    delList(index, row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          // 删除缓存
          let skuCodeList = [];
          skuCodeList.push(row.unique);
          this.clearCache(skuCodeList);
          this.detailList.splice(index, 1);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 选择省市区
    handleChange(val) {
      if (val.length) {
        this.options.forEach((i) => {
          if (i.value === val[0]) {
            this.form.address.province = i.label;
            i.children.forEach((j) => {
              if (j.value === val[1]) {
                this.form.address.city = j.label;
                // this.form.address.cityId = j.value;
                j.children.forEach((k) => {
                  if (k.value === val[2]) {
                    this.form.address.district = k.label;
                  }
                });
              }
            });
          }
        });
      } else {
        this.form.address = {
          city: null,
          province: null,
          district: null,
        };
      }
    },
    //inputNumber失去焦点后判断是否是数字
    inputNumBlur(row,type){
      if(!(!isNaN(parseFloat(row[type])) && isFinite(row[type]))){
        row[type] = 1
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.notice {
  max-width: 1400px;
  line-height: 56px;
  margin: 10px auto;
  position: relative;
}

.bread1 {
  height: 56px;
  display: inline-block;
  cursor: default;

  span {
    margin: 5px;
    font-size: 16px;

    font-weight: 400;
    color: #333333;
  }

  .btnAfter1 {
    cursor: pointer;
  }

  .btnAfter1:hover {
    color: #409eff;
  }
}

.address {
  .label {
    //background-color: #E6E6E6;
    padding: 0 20px;
    height: 57px;
    line-height: 57px;
    box-sizing: border-box;

    .add {
      img {
        width: 22px;
        height: 22px;
      }
    }
  }

  .active {
    //background-color: #F26E47;
    color: #333333;
    border-radius: 8px 8px 0 0;
  }

  .selectAddress {
    border: 2px solid #e4393c;
    padding: 10px;

    .addressInfo {
      .title {
        display: inline-block;
        width: 70px;
      }
    }
  }

  .pickupInfo {
    border: 2px solid #e4393c;
    padding: 10px;

    .store {
      img {
        width: 8px;
        height: 13px;
      }
    }

    .contactInfo {
      .title {
        display: inline-block;
        width: 80px;
      }
    }
  }
}

.contactDetails {
  width: 600px;
}

.addressList2 {
  .addressBox2 {
    padding: 20px;
    border: 2px solid #ccc;
    margin-bottom: 20px;
    font-size: 18px;

    p {
      line-height: 1.7;
    }

    .edit,
    .defaultAddress,
    .setDefault {
      line-height: 1.7;
    }
  }

  .active2 {
    border-color: #e4393c;
    background-color: #fffbfa;
  }
}
.el-input-number{
  width: 55px;
}
</style>



// WEBPACK FOOTER //
// src/views/quickly/index.vue